import {
	Component,
	OnInit,
	Output,
	EventEmitter,
	Input,
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	HostListener,
	ElementRef
} from "@angular/core";
import { Subscription } from "rxjs";

import { ButtonState } from "./button";
import { RoyaltyButtonService } from "./button.service";

@Component({
	selector: "royalty-button",
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: "button.component.html",
	styleUrls: ["button.component.css"]
})
export class RoyaltyButtonComponent implements OnInit {
	@Output() onClick: EventEmitter<boolean> = new EventEmitter();

	@Input() disabled: boolean;

	@Input() textButton: string = "OK";

	@Input() textProcessing: string = "Processing";

	@Input() color: string = "primary";

	isProcessing: boolean = false;

	private subscription: Subscription;

	isOnIt: boolean = false;

	constructor(
		private el: ElementRef,
		private cdr: ChangeDetectorRef,
		private loaderService: RoyaltyButtonService
	) {}

	@HostListener("document:click", ["$event"])
	handleClick(event: Event) {
		if (this.el.nativeElement.contains(event.target)) {
			this.isOnIt = true;
		} else {
			this.isOnIt = false;
		}
	}

	ngOnInit() {
		this.subscription = this.loaderService.loaderState.subscribe(
			(state: ButtonState) => {
				this.isProcessing = state.isProcessing;
				this.cdr.detectChanges();
			}
		);
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onClickButton() {
		this.onClick.emit(true);
	}
}
